import {
  cibFacebook,
  cibTwitter,
  cibLinkedin,
  cibFlickr,
  cibTumblr,
  cibXing,
  cibGithub,
  cibYoutube,
  cibDribbble,
  cibInstagram,
  cibPinterest,
  cibVk,
  cibYahoo,
  cibBehance,
  cibReddit,
  cibVimeo,
  cibCcMastercard,
  cibCcVisa,
  cibStripe,
  cibPaypal,
  cibGooglePay,
  cibCcAmex,
  cibSkype,
  cibDiscover,
  cilPlaylistAdd,
  cilWarning,
  cilWindowMaximize,
  cilSwapVertical
} from '@coreui/icons'
import {
  cifUs,
  cifBr,
  cifIn,
  cifFr,
  cifEs,
  cifPl
} from '@coreui/icons'
import {
  cilArrowRight,
  cilBan,
  cilBasket,
  cilBell,
  cilCalculator,
  cilCalendar,
  cilCloudDownload,
  cilChartPie,
  cilCheck,
  cilChevronBottom,
  cilChevronTop,
  cilChevronCircleUpAlt,
  cilChevronCircleDownAlt,
  // cilCircleCheck,
  cilCommentSquare,
  cilCursor,
  cilDrop,
  cilDollar,
  cilEnvelopeClosed,
  cilEnvelopeOpen,
  cilEuro,
  cilFax,
  cilGlobeAlt,
  cilGrid,
  cilFile,
  cilJustifyCenter,
  cilLaptop,
  cilLayers,
  cilLightbulb,
  cilList,
  cilLocationPin,
  cilLockLocked,
  cilMagnifyingGlass,
  cilMoon,
  cilPencil,
  cilPeople,
  cilPuzzle,
  cilSettings,
  cilShareAlt,
  cilShieldAlt,
  cilSpeech,
  cilSpeedometer,
  cilStar,
  cilTask,
  cilUser,
  cilUserFemale,
  cilUserFollow,
  cilXCircle,
  cilBug,
  cilBuilding,
  cilMedicalCross,
  cilLibrary,
  cilLibraryAdd,
  cilHospital,
  cilPlus,
  cilMinus,
  cilChart,
  cilChartLine,
  cilFilter,
  cilClock,
  cilCaretLeft,
  cilCaretRight,
  cilOptions,
  cilInfo,
  cilPhone,
  cibMailRu,
  cilCheckCircle,
  cilTrash,
  cilAlarm,
  cilBriefcase,
  cilRss,
  cilUserUnfollow,
  cilCommentBubble,
  cilSave,
  cilCloudUpload
} from '@coreui/icons'

export const iconsSet = Object.assign(
  {},
  {
    cilInfo,
    cilOptions,
    cilArrowRight,
    cilBan,
    cilBasket,
    cilBell,
    cilCalculator,
    cilCalendar,
    cilCloudDownload,
    cilChartPie,
    cilCheck,
    cilChevronBottom,
    cilChevronTop,
    cilChevronCircleUpAlt,
    cilChevronCircleDownAlt,
    cilCheckCircle,
    // cilCircleCheck,
    cilCommentSquare,
    cilCursor,
    cilDrop,
    cilDollar,
    cilEnvelopeClosed,
    cilEnvelopeOpen,
    cilEuro,
    cilGlobeAlt,
    cilGrid,
    cilFile,
    cilJustifyCenter,
    cilLaptop,
    cilLayers,
    cilLightbulb,
    cilList,
    cilLocationPin,
    cilLockLocked,
    cilMagnifyingGlass,
    cilMoon,
    cilPencil,
    cilPeople,
    cilPuzzle,
    cilSettings,
    cilShieldAlt,
    cilSpeech,
    cilSpeedometer,
    cilStar,
    cilTask,
    cilUser,
    cilUserFemale,
    cilUserFollow,
    cilXCircle,
    cilFilter,
    cilClock,
    cilCaretLeft,
    cilCaretRight,
    cilOptions,
    cilPhone,
    cilTrash,
    cilAlarm,
    cilBriefcase,
    cilChart,
    cilChartLine,
    cilRss,
    cilUserUnfollow,
    cilCommentBubble,
    cilWarning,
    cilWindowMaximize,
    cilSwapVertical,
    cilFax,
    cilShareAlt,
    cilSave,
    cilCloudUpload
  },
  {
    cifUs,
    cifBr,
    cifIn,
    cifFr,
    cifEs,
    cifPl
  },
  {
    cibMailRu,
    cibFacebook,
    cibTwitter,
    cibLinkedin,
    cibFlickr,
    cibTumblr,
    cibXing,
    cibSkype,
    cibGithub,
    cibYoutube,
    cibDribbble,
    cibInstagram,
    cibPinterest,
    cibVk,
    cibYahoo,
    cibBehance,
    cibReddit,
    cibVimeo,
    cibCcMastercard,
    cibCcVisa,
    cibStripe,
    cibPaypal,
    cibGooglePay,
    cibCcAmex,
    cilBug,
    cilBuilding,
    cilMedicalCross,
    cilLibrary,
    cilLibraryAdd,
    cilHospital,
    cilPlaylistAdd,
    cilPlus,
    cilMinus,
    cibDiscover
  }
)
